<template>
  <div class="tab-bar">
    <div v-for="(tab, index) in tabs" :key="index" class="tab-item" :class="{ active: currentTab === index }"
      @click="selectTab(index)">
      <img :src="currentTab === index ? tab.activeIcon : tab.icon" alt="tab-icon" class="tab-icon" />
      <span class="tab-text">{{ tab.text }}</span>
    </div>

    <wxchatPop v-if="qrcode" :visible="showPopup" :qrCode=qrcode :descriptionLine1="title"
      @close="showPopup = false" />
  </div>
</template>
  
<script>
import wxchatPop from "@/components/wxchatPop";

export default {
  components: {
    wxchatPop
  },
  name: "BottomTabBar",
  data() {
    return {
      qrcode: null,
      title:'长按二维码\n添加企业客服微信咨询',
      showPopup: false,
      currentTab: parseInt(localStorage.getItem("currentTab") || 0, 10), // 从 localStorage 获取当前选中 Tab
      tabs: [
        { text: "关于耐恒", icon: require('@/assets/images/common/tabIcon0.png'), activeIcon: require('@/assets/images/common/tabIcon0.png'), route: "/about" },
        { text: "联系我们", icon: require('@/assets/images/common/tabIcon1.png'), activeIcon: require('@/assets/images/common/tabIcon1.png'), route: "/contactUs" },
        { text: "客服", icon: require('@/assets/images/common/tabIcon2.png'), activeIcon: require('@/assets/images/common/tabIcon2.png'), route: "/profile" },
      ],
    };
  },
  methods: {
    getQrcode() {

      this.$http.get("/api/platform/banner/2", {}).then((res) => {
        this.qrcode = res.data.banner;
        this.title = res.data.title;
      });

    },
    selectTab(index) {
      this.currentTab = index;
      localStorage.setItem("currentTab", index); // 存储当前选中状态
      if (this.currentTab == 2) {
        this.getQrcode();
        this.showPopup = true;
      } else {
        this.$router.push(this.tabs[index].route); // 跳转路由
      }
      this.$dataStatistics('click', 'tabBar:' + this.tabs[index].text);
    },
  },
};
</script>
  
<style scoped>
.tab-bar {
  z-index: 50;
  position: fixed;
  bottom: 0;
  display: flex;
  justify-content: space-around;
  background-color: #fff;
  border-top: 1px solid #F3F3F3;
  padding: 10px 0;
  width: 100%;
}

.tab-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

.tab-item.active .tab-text {
  /* color: #42b983; */
}

.tab-text {
  font-size: 12px;
  margin-top: 5px;
  color: #5D5D61;
}

.tab-icon {
  width: 24px;
  height: 24px;
}
</style>